import { render, staticRenderFns } from "./PricingSection.vue?vue&type=template&id=64cc407c&"
import script from "./PricingSection.vue?vue&type=script&lang=js&"
export * from "./PricingSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports